/// <reference path="..//TS_definitions/leaflet-gesture-handling.d.ts" />
import * as $ from "jquery";
import * as L from "leaflet";
import "proj4leaflet";
import { Loader, LoaderOptions, google } from 'google-maps';
import * as bootstrap from "bootstrap";
//import { Proj4GeoJSONFeature } from "proj4leaflet";

let urlParams = new URLSearchParams(location.search),
    map: L.Map,
    crs: L.Proj.CRS,
    mapSettings: MapSettings,
    icons: { [name: string]: L.Icon } = {},
    iconsForStatus: { [name: string]: L.Icon },
    iconsForAssets: Record<string, L.Icon> = {},
    iconsForInfoLayers: Record<string, L.Icon> = {},
    case_type: string | undefined | null,
    borough: string | undefined | null,
    boroughBounds: L.LatLngBoundsExpression,
    openFaultImage: string,
    fiveDayFaultImage: string,
    addressPinImage: string,
    iconImage: string,
    assetLayerMinZoomLevel: number,
    assetAttributes: { [fieldName: string]: any } = {},
    infoLayerImage: string,
    legendSymbols: string[] = [],
    mapLayerGroup: L.FeatureGroup,
    infoLayerGroup: L.FeatureGroup,
    assetLayer: L.Layer,
    assetLabelsLayer: L.Layer,
    boroughMaskLayer: L.Layer,
    boroughBoundaryLayer: L.Layer,
    councilLandLayer: L.Layer,
    councilLayerMinZoomLevel: number = 10,
    faultsLayer: L.Layer,
    multipleFaultsLayer: L.Layer,
    zoomInMsgHTLM: string,
    multipleFaults: { [assetID: string]: string } = {},
    selectLayer: L.Marker,
    highlightLayer: L.CircleMarker,
    addressLayer: L.Marker,
    selectedLatForDisplay: number,
    selectedLngForDisplay: number,
    selectedFeatureX: number | null,
    selectedFeatureY: number | null,
    selectedAssetId: string = "",
    source: string | null = '',
    customerId: string | null = '',
    requiredParams: string[] = ['case_type', 'borough'],
    optionalParams: string[] = ['startLat', 'startLng', 'inForm'],
    startLat: number | null,
    startLng: number | null,
    inForm: boolean = false,
    hasZoomedIn: boolean = false,
    parentReady: boolean = false,
    mapReady: boolean = false,
    currentMapExtent: string = "",
    smallScreenWidth: number = 768,
    mapPopup: L.Popup,
    faultsPopup: L.Popup,
    //locatingOnLoad: boolean,
    baseurl: string,
    exlamationImagePath: string,
    addressBtn: any,
    addresSearchModal: bootstrap.Modal,
    msgModal: bootstrap.Modal,
    featuresWithFaults: any,
    google: google;


const options: LoaderOptions = {/* todo */ };
const loader = new Loader('AIzaSyC8fIDATqs5Ry79UH4vWpKEe2twtM50i1w', options);
                                                                                                                

loader.load().then(function (g) {
    google = g;
})


function showErrorScreen(message: string, consoleMessage: string) {

    let msg = <HTMLElement>document.getElementById('errorMessage'),
        errJumbo = <HTMLElement>document.getElementById('errorScreen'),
        map = <HTMLElement>document.getElementById('mapid'),
        addressSearch = <HTMLElement>document.getElementById('desktopAddressSearchDiv');


    msg.innerHTML = message;
    map.style.display = 'none';
    addressSearch.style.visibility = 'hidden';
    errJumbo.style.display = 'block';
    console.error(consoleMessage);
}

// Check if there are any errors with the mapping services
function serviceError(url: string) {
    sendErrorEmail("Service Error. URL is unavailable: " + url + " (Map: " + case_type + "Borough: " + borough + ")");
    showErrorScreen("We apologise but the mapping service is currently unavailable. The problem is being investigated and we hope to resolve the issue as soon as possible.", "Mapping service cannot be returned: " + url);
}

//*get the params from the url

requiredParams.forEach(function (p) {
    if (!urlParams.has(p)) {
        //show the error page
        showErrorScreen('missing parameters.', 'missing url parameters case_type/borough');
        return;
    }
});

case_type = urlParams.get('case_type');
borough = urlParams.get('borough');
//*get any startup coordinates
if (urlParams.has('startLat') && urlParams.get('startLat')) {
    let sl = urlParams.get('startLat');
    if (sl) {
        startLat = +sl;
    }
}
if (urlParams.has('startLng') && urlParams.get('startLng')) {
    let sl = urlParams.get('startLng');
    if (sl) {
        startLng = +sl;
    }
}
//*check if map is embedded in a cp form
if (urlParams.has('inForm') && urlParams.get('inForm')) {
    inForm = true;
    const timeout = 30_000;

    window.addEventListener("message", (e: MessageEvent) => {
        //  • you can tighten the origin check if you want
        if (e.data && e.data.type === "PARENT_READY") {
            console.log("Parent is ready");
            parentReady = true;
            clearTimeout(readyTimeout);       // cancel the watchdog
            makeMapVisible();
        }
    }, false);


    // start a timeout watchdog as soon as the app starts
    const readyTimeout = window.setTimeout(() => {
        if (!parentReady) {
            // parent never said “ready” within timeout period → fire your error handler
            let msg = "Form Parent is not ready after waiting " + timeout/1000 + "s. (Map: " + case_type + " Borough: " + borough + ")";
            sendErrorEmail(msg);
            showErrorScreen("We apologise but the mapping service is currently unavailable. The problem is being investigated and we hope to resolve the issue as soon as possible.", msg);
        }
    }, timeout); 

}
//**TESTING */
//inForm = true;
//TEST END

//*put any other parameters passed, into a dictionary
let optParams: string = '';

urlParams.forEach(function (value, key, parent) {
    if (value && !requiredParams.includes(key) && !optionalParams.includes(key)) {
        optParams += `&${key}=${value}`;
    }
});


baseurl = window.location.origin;
if (window.location.pathname !== '/') {
    baseurl += window.location.pathname;
}
//*call the web service to retrieve config settings
$.get(`${baseurl}/api/getMapSettings/${case_type}/${borough}`)
    .done(function (result) {
        mapSettings = result;
        initialise();
    })
    .fail(function (error) {

        showErrorScreen('server error.', `unable to retrieve map settings from server - ${error.statusText}`);
    });

//*Check if map is being viewed on mobile / tablet
function isMobileDevice() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
    }
}

function initialise() {
    // Setup the EPSG:27700 (British National Grid) projection.
    crs = new L.Proj.CRS('EPSG:27700', '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs', {
        resolutions: [896.0, 448.0, 224.0, 112.0, 56.0, 28.0, 14.0, 7.0, 3.5, 1.75, 0.875, 0.4375, 0.21875, 0.109375],
        origin: [-238375.0, 1376256.0]
    });


    //*gesture handling disabled. Requires "leaflet-gesture-handling": "1.2.1", adding to the package.json file
    //L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
    map = new L.Map("mapid", {
        crs: crs,
        attributionControl: false
        //fullscreenControl: true,
        //fullscreenControlOptions: {
        //    position: "topleft"
        //}
        //gestureHandling: false
    });
    // map.addControl(new L.Control.Fullscreen({}));



    map.whenReady(function () {
        //$('#sampleStartMenu').modal('show');
    });
    createIcons();
    createZoomInHTML();
    createLegendText();

    if (mapSettings.mapLayerFaultID) {
        getAttributesForFeaturesWithFaults(mapSettings.mapLayerFaultID);
    }

    addLayers();
    setUpEvents();
    addButtons();
    mapPopup = L.popup();
    faultsPopup = L.popup();
    boroughBounds = L.latLngBounds([[mapSettings.boroughBounds[0], mapSettings.boroughBounds[1]], [mapSettings.boroughBounds[2], mapSettings.boroughBounds[3]]]);
    if (startLat && startLng) {
        map.setView(L.latLng(startLat, startLng), 20);
    } else {
        map.setView(L.latLng(mapSettings.startUpCoords[0], mapSettings.startUpCoords[1]), 5);
        map.fitBounds(boroughBounds);
    }
    //map.gestureHandling.enable();

    addresSearchModal = new bootstrap.Modal('#addressSearchModal');
    msgModal = new bootstrap.Modal('#msgModal');

}


//#region Address Searching



function showModalAfterLocated() {
    let msgTitle: string = '',
        msgBody: string = '',
        mapMaxMsg: string = '';


    if (mapSettings.isAsset) {
        msgTitle = `Select the ${mapSettings.popupTitle}`;
        msgBody = `<p>Now click or tap ${legendSymbols.join(" or ")} with the problem.<p>`;

    } else {
        msgTitle = 'Select a location';
        msgBody = `<p>Now click or tap on the map to select a location.</p>`;
    }

    showMessageModal(msgTitle, msgBody, 'OK', modalType.info);
}

function zoomToAddress(lat: number, lng: number, address: string) {

    map.setView(L.latLng(lat, lng), 12);
    showModalAfterLocated();

}

function returnAddresses(searchText: string) {
    let addressSearchSpinner = <HTMLElement>document.getElementById('addressSearchSpinner'),
        addressSearchMessage = <HTMLElement>document.getElementById('addressSearchMessage'),
        listbox = <HTMLElement>document.getElementById("searchlist-modal");

    if (addressSearchSpinner) {
        addressSearchSpinner.style.visibility = 'visible';
    }


    $.ajax({
        crossDomain: true,
        type: 'GET',
        dataType: 'json',
        url: mapSettings.addressServiceUrl + searchText,

    })
        .always(function () {
            addressSearchSpinner.style.visibility = 'hidden'; //* loading gif
        })
        .done(function (result) {
            let addresses: Address[] = [];
            for (let a of result.Addresses) {
                let address: Address = a;
                addresses.push(address);
            }
            if (addresses.length === 0) {
                //*no address found
                $("#searchlistdiv-modal").removeClass().addClass("searchListHide");
                addressSearchMessage.style.display = 'inline';
                $("#addSearchHeader").removeClass('dialogHeaderSuccess dialogHeaderInfo');
                $("#addSearchHeader").addClass('dialogHeaderWarning');

            } else {
                if (addresses.length === 1) {
                    addresSearchModal.hide();
                    //$("#addressSearchModal").modal("hide");
                    $("#searchlistdiv-modal").removeClass().addClass("searchListHide");
                    let address = addresses[0];
                    zoomToAddress(address?.Latitude, address?.Longitude, address.FormattedAddress);

                } else {
                    let items: string = "";
                    for (let i of addresses) {
                        items += `<li class="list-group-item" id="${i.Uprn}">${i.FormattedAddress}</li>`;
                    }
                    listbox.innerHTML = items;

                    //*set styling
                    $("#searchlistdiv-modal").removeClass().addClass("searchListShow");
                    $("#addSearchHeader").removeClass('dialogHeaderWarning dialogHeaderInfo');
                    $("#addSearchHeader").addClass('dialogHeaderSuccess');
                    addressSearchMessage.style.display = 'none';

                    //*setup click event for when an address in the list is clicked
                    $('#searchlist-modal li').on('click', function (e) {
                        let address = addresses.find(item => {
                            return item.Uprn.toString() == e.target.id;
                        });
                        if (address) {
                            zoomToAddress(address?.Latitude, address?.Longitude, address.FormattedAddress);
                            addresSearchModal.hide();
                            //$("#addressSearchModal").modal("hide");
                        }

                    })
                }
            }
        })
        .fail(function (jqXHR, textStatus, error) {

            addressSearchMessage.style.display = 'inline';
            addressSearchMessage.innerHTML = `<p><img src="${exlamationImagePath}" alt='error' /></p><p>Sorry, there is a problem finding the address.</p>`;

            console.error(textStatus);
        })

}

function addressSearchFromDesktop() {

    let sidEl = <HTMLInputElement>document.getElementById("searchInputDesktop");
    let modalSearchEl = <HTMLInputElement>document.getElementById("searchInput");
    let searchText: string = sidEl.value;
    modalSearchEl.value = searchText;
    addresSearchModal.show();
    returnAddresses((<HTMLInputElement>document.getElementById("searchInput")).value);
}
//#endregion

//#region Misc Helper methods

function createZoomInHTML() {
    zoomInMsgHTLM = `<span id="alertPopup"><img src="${exlamationImagePath}"/><p> You must zoom in to select a location.<br /><div class = "d-grid gap-2 mx-auto"><button type="button" id="btnZoomToReportLevel" class = "btn btn-primary btn-block">Zoom In</button></div></p></span>`
}

function createLegendText() {
    let legendContent = <HTMLElement>document.getElementById('legendContent'),
        iconPath: string = "",
        legendSymbol: string = "",
        mapKey = [],
        html: string;

    if (!mapSettings.no_Legend) {
        mapKey.push(`<img src =${openFaultImage} alt = "red warning triangle picture" style = 'width:20px;height:20px;margin-bottom:-2px;' > are open reports.`);
        mapKey.push(`<img src = ${fiveDayFaultImage} alt = "yellow warning triangle picture" style = 'width:20px;height:20px;margin-bottom:-2px;'> are recently closed reports.`);
    }

    if (mapSettings.infoLayers) {
        //*info layers
        for (let infoLayer of mapSettings.infoLayers) {
            for (let symSettings of infoLayer.symbology) {
                iconPath = `${baseurl}/images/${symSettings.icon}`;

                mapKey.push(`<img src =${iconPath} alt = "${symSettings.name} picture" style = 'width:${symSettings.iconSizeLegend[0]}px;height:${symSettings.iconSizeLegend[1]}px;margin-top:${symSettings.iconLegendMargins[0]}px;margin-bottom:${symSettings.iconLegendMargins[1]}px;' > ${symSettings.name}.`);
            }
        }
    }

    if (mapSettings.isAsset) {
        //*ASSET layer
        for (let symSettings of mapSettings.symbology) {
            iconPath = `${baseurl}/images/${symSettings.icon}`;

            legendSymbol = `<img src ="${iconPath}" alt= "${symSettings.name} picture" style='width:${symSettings.iconSizeLegend[0]}px;height:${symSettings.iconSizeLegend[1]}px;'>`
            legendSymbols.push(legendSymbol);

            mapKey.push(`<img src =${iconPath} alt = "${symSettings.name} picture" style = 'width:${symSettings.iconSizeLegend[0]}px;height:${symSettings.iconSizeLegend[1]}px;margin-top:${symSettings.iconLegendMargins[0]}px;margin-bottom:${symSettings.iconLegendMargins[1]}px;' > ${symSettings.name}.`);
        }

        html = `<p class='assetMsg'><span id='legendZoomMsg'>1. Use the search above or zoom into the map to find the location.<br />2. Click or tap </span>${legendSymbols.join(" or ")} to select a location.</span></p>`;
    } else {
        html = `<p class='nonAssetMsg'><span id='legendZoomMsg'>1. Use the search above or zoom into the map to find the location.<br />2. Click or tap on the map to select a location.</span><br><span id='legendCouncilZoomMsg' style='display:none;font-style:italic'>The council is only responsible for areas shaded <span style='color:orange;'>█</span></span></p>`;
    }

    if (!mapSettings.no_Legend) {
        html += `<p><span id='legendKey'>Map Key:<br />${mapKey.join('<br />')}</p>`;
    }
    legendContent.innerHTML = html
}

function showMessageModal(title: string, message: string, btnText: string = 'Close', type: modalType = modalType.info) {
    let msgTitle = <HTMLElement>document.getElementById('msgModalLabel'),
        msgMessage = <HTMLElement>document.getElementById('msgModalMessage'),
        btnMessage = <HTMLElement>document.getElementById('modalCloseBtn');

    msgTitle.innerHTML = title;
    msgMessage.innerHTML = message;
    btnMessage.innerHTML = btnText;

    $("#msgModalHeader").removeClass(`${modalType.info} ${modalType.success} ${modalType.warning}`);
    $("#msgModalHeader").addClass(type);

    msgModal.show();
}

function generateHtmlForPopup(feature: any) {
    let html: string;

    if (feature.layer === mapSettings.singleFaultsLayerID) {
        if (feature.properties.STATUS == 'FIVE') {
            html = `<p>Case ref: <span>${feature.properties.CASENO}</span><br><strong>Closed</strong> on ${new Date(feature.properties.DATE_CLOSED).toDateString()}</p>`;
        } else {
            html = `<p>Case ref: <span>${feature.properties.CASENO}</span><br><strong>Raised</strong> on ${new Date(feature.properties.DATE_CREATED).toDateString()}</p>`;
        }
        if (feature.properties.NOTES) {
            html += `<p id=popupNotes>${feature.properties.NOTES}</p>`;
        }
    } else {
        html = '';
        for (const key of Object.keys(feature.properties)) {
            const value = feature.properties[key];
            if (value.STATUS == 'FIVE') {
                html += `<p>Case ref: <span>${value.CASENO}</span><br><strong>Closed</strong> on ${new Date(value.DATE_CLOSED).toDateString()}</p>`;
            } else {
                html += `<p>Case ref: <span>${value.CASENO}</span><br><strong>Raised</strong> on ${new Date(value.DATE_CREATED).toDateString()}</p>`;
            }
            if (value.NOTES) {
                html += `<p id=popupNotes>${value.NOTES}</p>`;
            }
            html += `<hr>`;
        }
    }
    return html;
}

function postMessageToForm(
    latitude: number,
    longitude: number,
    assetid: string = "",
    case_type: string = ""
) {
    // build the result payload
    const base: MapResult = { latitude, longitude, assetid, case_type };
    const mapResult: MapResult = (
        assetAttributes && Object.keys(assetAttributes).length
            ? { ...base, ...assetAttributes }
            : base
    );

    if (parentReady) {
        //  Granicus form 'Parent' is listening
        window.parent.postMessage(mapResult, "*");
    } else {
        // Throw an exception as the map should not be visible unless the parent is ready
        const msg = "Attempted to post message to form but the form is not listening.";
        sendErrorEmail(msg + " (Map: " + case_type + "Borough: " + borough + ")");
        showErrorScreen("We apologise but there is a problem with the map. The problem is being investigated and we hope to resolve the issue as soon as possible.", msg);
    }
}

function makeMapVisible() {
    if (inForm) {
        if (parentReady && mapReady) {
            //Hide the spinner
            $('#working').css("visibility", "hidden");
        }
    } else {
        if (mapReady) {
            //Hide the spinner
            $('#working').css("visibility", "hidden");
        }
    }

}

function getAssetAttributes(): string {
    let assetAttributeParams: string = '';
    if (assetAttributes) {
        for (let attribute in assetAttributes) {
            assetAttributeParams += "&" + attribute + "=" + assetAttributes[attribute];
        }
    }
    return assetAttributeParams;
}

function clickEventHandlerForYesButton() {
    let lat: number = selectedLatForDisplay;
    let lng: number = selectedLngForDisplay;
    let newLat: number | null = null;
    let newLng: number | null = null;
    //let latDiff: number;
    //let lngDiff: number;

    //*Convert lat / lng to BNG coordinates for re-conversion if non asset
    let xyConverted = crs.project({ lat, lng });
    let xForConversion = xyConverted.x;
    let yForConversion = xyConverted.y;

    const handleClick = function (lat: number, lng: number) {
        if (inForm) {
            map.closePopup();
            if (selectedAssetId) {
                if (highlightLayer) {
                    highlightLayer.remove();
                }
                highlightLayer = L.circleMarker(L.latLng(selectedLatForDisplay, selectedLngForDisplay), {
                    color: 'red',
                    fillColor: '#f03',
                    fillOpacity: 0.5,
                    radius: 50
                });
            }
            if (highlightLayer) {
                highlightLayer.addTo(map);
            }
            map.panTo(L.latLng(selectedLatForDisplay, selectedLngForDisplay));
            postMessageToForm(lat, lng, selectedAssetId, case_type?.toString());
        } else {
            //*show working screen
            $('#working').css("visibility", "visible");
            //*check for additional asset attributes
            let assetAttributeParams: string = getAssetAttributes();
            let firmstepUrl: string = `${mapSettings.formUrl}?&lat=${lat}&lng=${lng}&assetid=${selectedAssetId}&case_type=${case_type}${assetAttributeParams}`;
            //*add any additional parameters included in the map url to the form url
            if (optParams) {
                firmstepUrl += optParams;
            }
            window.open(firmstepUrl, '_top');
        }
    };

    //*Set the coordinates for conversion using the asset feature if an asset
    if (selectedFeatureX && selectedFeatureY) {
        xForConversion = selectedFeatureX;
        yForConversion = selectedFeatureY;
    }

    //**Get the more accurate lat/long for both assets with existing BNG coordinates, or non assets with inaccurate transformed coordinates*/
    $('#working').css("visibility", "visible");
    let accConversion = returnLatLongFromOScoords(xForConversion, yForConversion);
    accConversion.then((coords) => {
        newLat = coords.lat;
        newLng = coords.lng;
        //latDiff = Math.abs(lat - newLat);
        //lngDiff = Math.abs(lng - newLng);

    }).catch((error) => {
        sendErrorEmail(`returnLatLongFromOScoords Error. Using Lat: ${lat} Lng: ${lng} Error msg: ${error.statusText}`);
        //console.log(error); no point writing to console as redirecting to form

    }).finally(() => {
        $('#working').css("visibility", "hidden");
        if (newLat == null || newLng == null) {
            handleClick(lat, lng);
        } else {
            handleClick(newLat, newLng);
        }

    })

}

//*event handler to close the popup when the 'Yes' button is clicked on the report a fault popup
$('#mapid').on('click', '#btnNewFault', function (e) {
    clickEventHandlerForYesButton();
});


function returnHTMLforNewFaultPopup(lat: number, lng: number, land_type: string = '', assetid: string = ''): Promise<HTMLDivElement> {

    let popupContent = document.createElement("div"),
        popupHeader = document.createElement("div"),
        popupBody = document.createElement("div"),
        googleDiv = document.createElement("div"),
        panoDiv = document.createElement("div"),
        popupFooter = document.createElement("div"),
        isSmallScreen = $(window).width()! < smallScreenWidth,
        locationText: string;

    popupContent.id = 'popUpContentDiv';
    popupBody.id = 'popUpBodyDiv';
    googleDiv.id = 'googleDiv';
    panoDiv.id = 'panoDiv';

    let pano: google.maps.StreetViewPanorama;

    function getGoogleImage() {

        let googleLatLng = new google.maps.LatLng(lat, lng),
            msgText: string = "";

        //*check if there's a street view within 5m of the clicked location
        let request: google.maps.StreetViewLocationRequest = {
            location: googleLatLng,
            radius: 5,
            source: google.maps.StreetViewSource.OUTDOOR
        };
        let streetViewService = new google.maps.StreetViewService();
        streetViewService.getPanorama(request, function (data: google.maps.StreetViewPanoramaData | null, status: google.maps.StreetViewStatus) {
            if (status == "OK") {
                msgText = "as an additional guide, here's a street view from this location...";
                googleDiv.innerHTML = `<p id = "googleMsgText">${msgText}</p>`;
                googleDiv.appendChild(panoDiv);

                var heading = google.maps.geometry.spherical.computeHeading(data?.location?.latLng!, googleLatLng);

                let panOptions: google.maps.StreetViewPanoramaOptions = {
                    //position: googleLatLng,
                    pano: data?.location?.pano,
                    pov: {
                        heading: heading,
                        pitch: 0
                    },
                    addressControl: false,
                    clickToGo: false,
                    disableDefaultUI: false,
                    disableDoubleClickZoom: true,
                    enableCloseButton: false,
                    fullscreenControl: true,
                    linksControl: false,
                    motionTracking: true,
                    visible: true
                };
                pano = new google.maps.StreetViewPanorama(panoDiv, panOptions);
                let panid: string;

            } else {
                msgText = "as an additional guide, here's an aerial view of this location...";
                googleDiv.innerHTML = `<p id = "googleMsgText">${msgText}</p>`;
                googleDiv.appendChild(panoDiv);

                let styles: any = {
                    hide: [
                        {
                            featureType: 'poi.business',
                            stylers: [{ visibility: 'off' }]
                        }
                    ]
                };

                const gMap = new google.maps.Map(panoDiv, {
                    center: googleLatLng,
                    draggable: false,
                    mapTypeId: google.maps.MapTypeId.HYBRID,
                    tilt: 45,
                    zoom: 18,
                    mapTypeControl: false,
                    panControl: false,
                    rotateControl: false,
                    scaleControl: true,
                    scrollwheel: true,
                    streetViewControl: false,
                    zoomControl: true
                });

                gMap.setOptions({ styles: styles['hide'] });

                let marker = new google.maps.Marker({
                    clickable: false,
                    map: gMap,
                    position: googleLatLng
                });

            }

        });
    }

    let pArray: Array<any> = [returnLocationDescription(lat, lng)];


    const promise: Promise<HTMLDivElement> = new Promise((resolve, reject) => {

        Promise.all(pArray).then(function (results) {
            let searchPointType: string = "point";
            if (mapSettings.isAsset) {
                searchPointType = mapSettings.popupTitle.toLowerCase();
            }
            let privateLandNote: string = "";
            if (land_type == "private" && mapSettings.allow_Private && mapSettings.private_Land_Msg) {
                privateLandNote = `<p id="privateLandNote"><span>${mapSettings.private_Land_Msg}</span><p>`;
            }
            let onLocationDescriptionResult: string = results[0];
            if (onLocationDescriptionResult) {
                popupBody.innerHTML = `<p id ="locationDescription">you've chosen a ${searchPointType}:- <br>${onLocationDescriptionResult}</p>${privateLandNote}<h5 id = "popupUserPromptMsg">Choose this location?</h5>`;
            } else {
                popupBody.innerHTML = `<h4 id = "popupUserPromptMsg">Choose this location?</h4>`;
            }

            if (results[1]) {
                pano.setPano(results[1]);
            }

            //*Add buttons to popup for reporting a new fault
            let yesButtonHtml = '<br><button type="button" id="btnNewFault" class="btn btn-primary btn-lg"> Yes </button>';
            let noButtonHtml = '\n<button type="button" id="btnNo" class = "btn btn-secondary btn-lg"> No </button>';
            popupFooter.innerHTML = yesButtonHtml + noButtonHtml;

            /* Need to hide 360 images until billing is fixed
            if (!isSmallScreen) {
                getGoogleImage();
                popupContent.appendChild(googleDiv);
            }
            */
            popupContent.appendChild(popupBody);
            popupContent.appendChild(popupFooter);

            resolve(popupContent);
        })
    })
    return promise;

}

function returnHTMLforAssetFaultPopup(feature: any): HTMLDivElement {
    let popupContent = document.createElement("div"),
        popupHeader = document.createElement("div"),
        popupBody = document.createElement("div"),
        popupFooter = document.createElement("div");

    popupContent.id = 'popUpContentDiv';
    popupBody.id = 'popUpBodyDiv';

    let lat: number = feature?.geometry.coordinates[1],
        lng: number = feature?.geometry.coordinates[0],
        assetId: string = feature?.properties.ASSETID;

    //*if the feature has multiple faults, use the html from the multipleFaults object, otherwise use the features attributes
    if (multipleFaults[assetId]) {
        popupBody.innerHTML = multipleFaults[assetId];
    } else {
        popupBody.innerHTML = generateHtmlForPopup(feature.properties);
    }

    //*Add button to popup for reporting a new fault
    let anotherIssueButtonHtml = '<br><button type="button" id="btnNewFault" class="btn btn-primary btn-lg">Report a different issue</button>';

    popupFooter.innerHTML = anotherIssueButtonHtml;

    popupHeader.innerHTML = "<h3>" + mapSettings.popupTitle + "</h3>";
    popupContent.appendChild(popupHeader);
    popupContent.appendChild(popupBody);
    popupContent.appendChild(popupFooter);

    return popupContent;
}


//#endregion

//#region Map Setup



function addButtons() {
    const locateBtn = L.Control.extend({
        options: {
            position: 'topleft'
        },

        onAdd: function (map: L.Map) {
            const container = L.DomUtil.create('div', 'leaflet-control-locate leaflet-bar leaflet-control'),
                link = L.DomUtil.create('a', 'leaflet-bar-part', container);
            link.id = "leafletLocate";
            link.title = "Show me where I am..";

            L.DomEvent.addListener(link, 'click', function () {
                map.locate();
            })
            L.DomEvent.disableClickPropagation(container);

            return container;
        }

    });
    map.addControl(new locateBtn);

    //*Add an 'open in new tab' button IF the map is in an iframe on the websites

    if ((window.location != window.parent.location)) {

        let parentUrl: string;
        if (window.location.ancestorOrigins) {
            parentUrl = window.location.ancestorOrigins[0];
        } else {
            parentUrl = document.referrer;
        }
        console.log('parentUrl: ' + parentUrl);

        if (parentUrl.includes('www.sutton.gov.uk') || parentUrl.includes('www.kingston.gov.uk')) {
            const openInNewTabBtn = L.Control.extend({
                options: {
                    position: 'topleft'
                },

                onAdd: function (map: L.Map) {
                    const container = L.DomUtil.create('div', 'leaflet-control-newtab leaflet-bar leaflet-control'),
                        link = L.DomUtil.create('a', 'leaflet-bar-part', container);
                    link.id = "leafletOpenInNewTab";
                    link.title = "Open fullscreen in a new tab.";

                    L.DomEvent.addListener(link, 'click', function () {
                        window.open(location.toString(), '_blank');
                    })
                    L.DomEvent.disableClickPropagation(container);

                    return container;
                }

            });
            map.addControl(new openInNewTabBtn);
        }
    }



    const legendBtn = L.Control.extend({
        options: {
            position: 'topleft'
        },

        onAdd: function (map: L.Map) {
            const container = L.DomUtil.create('div', 'leaflet-control-legend leaflet-bar leaflet-control'),
                link = L.DomUtil.create('a', 'leaflet-bar-part', container);
            link.id = "leafletLegend";
            link.title = "Show/Hide Legend.";

            L.DomEvent.addListener(link, 'click', function () {
                if ($('#legend').css("visibility") === "visible") {
                    $('#legend').css("visibility", "hidden");
                    $('#legendCloseBtn').css("visibility", "hidden");
                } else {
                    $('#legend').css("visibility", "visible");
                    $('#legendCloseBtn').css("visibility", "visible");
                }
            })
            L.DomEvent.disableClickPropagation(container);

            return container;
        }

    });
    map.addControl(new legendBtn);





}

function toggleScreenElements(blnHide: boolean) {
    let strVis: string,
        isSmallScreen = $(window).width()! < smallScreenWidth;
    if (blnHide) {
        strVis = "hidden";
    } else {
        strVis = "visible";
    }

    $('#desktopAddressSearchDiv').css("visibility", `${strVis}`);
    $('#mapid > div.leaflet-control-container > div.leaflet-top.leaflet-left').css("visibility", `${strVis}`);
    //*only want to show the legend button on small screens
    if (!blnHide) {
        $("#mapTooltip").css("display", "inline-block");

        if (isSmallScreen) {
            //*show legend button only
            $('.leaflet-control-legend').css("visibility", `${strVis}`);
        } else {
            //*show legend
            $('#legend').css("visibility", `${strVis}`);
        }


        if (isMobileDevice()) {
            //*hide tooltip on mobile devices
            $("#mapTooltip").css("display", "none");
        }
    } else {
        $("#mapTooltip").css("display", "none");
        $('.leaflet-control-legend').css("visibility", `${strVis}`);
        $('#legend').css("visibility", `${strVis}`);
        $('#legendCloseBtn').css("visibility", `${strVis}`);


    }


}

function createIcons() {
    let i = L.icon({
        iconUrl: baseurl + "/images/" + 'cursorPin.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });
    icons['pin'] = i;

    openFaultImage = baseurl + "/images/" + 'openFault.png';
    i = L.icon({
        iconUrl: openFaultImage,
        iconSize: [32, 32],
        iconAnchor: [16, 16],
        popupAnchor: [0, -16]
    });
    icons['openFault'] = i;

    fiveDayFaultImage = baseurl + "/images/" + 'fiveDayFault.png';
    i = L.icon({
        iconUrl: fiveDayFaultImage,
        iconSize: [32, 32],
        iconAnchor: [16, 16],
        popupAnchor: [0, -16]
    });
    icons['fiveDayFault'] = i;

    addressPinImage = baseurl + "/images/" + 'GreenPin1LargeB.png';
    i = L.icon({
        iconUrl: addressPinImage,
        iconSize: [50, 50],
        className: 'iconFade'
    });
    icons['addressPinImage'] = i;

    let featureSymbology: FeatureSymbology[] = [];

    if (mapSettings.symbology) {
        featureSymbology.push({ type: "AssetLayer", symbology: mapSettings.symbology });
    }

    if (mapSettings.infoLayers) {
        for (let infoLayer of mapSettings.infoLayers) {
            featureSymbology.push({ type: "InfoLayer", symbology: infoLayer.symbology });
        }
    }

    if (featureSymbology) {
        for (let layer of featureSymbology) {
            for (let symSettings of layer.symbology) {
                iconImage = baseurl + "/images/" + symSettings.icon;
                let iconKey: string = symSettings.name;
                i = L.icon({
                    iconUrl: iconImage,
                    iconSize: symSettings.iconSize,
                    iconAnchor: symSettings.iconAnchor,
                    popupAnchor: symSettings.popupAnchor
                });
                icons[symSettings.name] = i;

                if (symSettings.filter) {
                    iconKey = symSettings.filter;
                }
                if (layer.type == "AssetLayer") {
                    iconsForAssets[iconKey] = icons[symSettings.name];
                }
                if (layer.type == "InfoLayer") {
                    iconsForInfoLayers[iconKey] = icons[symSettings.name];
                }

            }
        }
    }

    iconsForStatus = { OPEN: icons['openFault'], FIVE: icons['fiveDayFault'] };
    exlamationImagePath = baseurl + "/images/exclamation.png";
}

function setUpEvents() {


    map.on("load", function (e) {
        console.log("Map loaded");
        mapReady = true;
        makeMapVisible();
    })

    //*Set up map tooltip movement
    $('#mapid').on('mousemove', function (e) {
        $('#mapTooltip').css("opacity", "0.9");
        $('#mapTooltip', this).css({ left: e.pageX + 10, top: e.pageY - 10 });
    });

    //*Hide tooltip for touch events / display legend if hidden from small screen toggling
    $('#mapid').on({
        'touchstart': function () {
            $('#mapTooltip').css("display", "none");
        }
    });

    //*disable map click events for non map div ids and change cursor on mouse over
    const divElements = ["legend", "addressSearchModal", "desktopAddressSearchDiv", "msgModal"];
    divElements.forEach(function (e) {
        let selectedElement = <HTMLElement>document.getElementById(e);
        L.DomEvent.disableClickPropagation(selectedElement);
        $(selectedElement).on('mousemove', function () {
            selectedElement.style.cursor = "default";
            $("#mapTooltip").css("display", "none");
        });
        $(selectedElement).on('mousemove', function () {
            $("#mapTooltip").css("display", "inline-block");
        });
    });

    //*disable map tooltips when over leaflet controls
    $(".leaflet-control-container").on('mousemove', function () {
        $("#mapTooltip").css("display", "none");
    });
    $(".leaflet-control-container").on('mouseout', function () {
        $("#mapTooltip").css("display", "inline-block");
    });

    //*toggle mouse wheel zoom scrolling for address search display
    let asModal = document.getElementById('addressSearchModal');
    if (asModal) {
        asModal.addEventListener('show.bs.modal', function (event) {
            map.scrollWheelZoom.disable();
        });
        asModal.addEventListener('hide.bs.modal', function (event) {
            map.scrollWheelZoom.enable();
        });
    }


    $('#btnAddressSearch').on('click', function (e) {
        returnAddresses((<HTMLInputElement>document.getElementById("searchInput")).value);
    });

    $("#searchInput").on('keydown', function (e) {
        if (e.key === 'Enter') {
            returnAddresses((<HTMLInputElement>document.getElementById("searchInput")).value);
        }
    });

    $("#searchInputDesktop").on('keydown', function (e) {
        if (e.key === 'Enter') {
            addressSearchFromDesktop();
        }
    });

    $("#btnAddressSearchDesktop").on('click', function (e) {
        addressSearchFromDesktop();
    });

    //*Hide legend on legend close button click
    $("#legendCloseBtn").on('click', function () {
        $('#legend').css("visibility", "hidden");
        $('#legendCloseBtn').css("visibility", "hidden");
    })

    //*event handler to close the popup when the 'No' button is clicked on the report a fault popup
    $('#mapid').on('click', '#btnNo', function (e) {
        map.closePopup();
        //*remove the pin
        if (selectLayer) {
            selectLayer.remove();
        }
        if (highlightLayer) {
            highlightLayer.remove();
        }
    });

    //*event handler to zoom in to first available map level to report when user clicks on map zoomed out too far
    $('#mapid').on('click', '#btnZoomToReportLevel', function () {
        if (mapPopup) {
            let mapCoords = mapPopup.getLatLng();
            if (mapCoords) {
                map.setView(L.latLng(mapCoords.lat, mapCoords.lng), mapSettings.mapLayerMinZoom);
            }
            map.closePopup();
        }
    });


    function showMapPopup(latLng: L.LatLng, content: string) {

        //*hide the other screen elements
        $('#working').css("visibility", "hidden");
        toggleScreenElements(true);

        mapPopup.setLatLng(latLng);
        mapPopup.setContent(content);
        map.openPopup(mapPopup);

        window.setTimeout(function () {
            if (mapPopup.isOpen()) {
                map.closePopup(mapPopup);
            }
        }, 6000);

        map.on("popupclose", function (e) {
            //*show the other screen elements
            toggleScreenElements(false);
        })
    }

    function showFaultPopup(e: L.LeafletMouseEvent) {
        //*set selected coordinates and asset id
        selectedLatForDisplay = e.latlng.lat;
        selectedLngForDisplay = e.latlng.lng;
        let feature = e.sourceTarget.feature;
        let prop = feature.properties;
        if (feature.properties?.length >= 1) {
            prop = feature.properties[0];
        }
        let xy = feature.geometry.coordinates;
        selectedFeatureX = xy[0];
        selectedFeatureY = xy[1];
        selectedAssetId = prop.ASSETID;

        if (mapSettings.out_Parameters) {
            /*Need to get the additional attributes from the featuresWithFaults geoJson
             * as they won't be held in the fault feature*/
            if (featuresWithFaults) {
                let faultId = prop.ASSETID;
                let asset: any = null;
                for (let feature of featuresWithFaults) {
                    if (feature.properties.ASSETID == faultId) {
                        asset = feature;
                        break;
                    }
                }
                let fieldList: string[] = mapSettings.out_Parameters.split(',');
                assetAttributes = {};
                fieldList.forEach((e) => {
                    for (let attribute in asset.properties) {
                        if (e == attribute) {
                            assetAttributes[e] = asset.properties[attribute];
                        }
                    }
                });
                console.log(assetAttributes);
            }
            else {
                /*Should only get here if the layers haven't been set-up correctly
                 *or not been able to load completely so email error and show the error page.*/
                let msg: string = "Map configured to return additional output parameters but the featuresWithFaults collection is empty. ";
                sendErrorEmail(msg + " (Map: " + case_type + "Borough: " + borough + ")");
                showErrorScreen("We apologise but the mapping service is currently unavailable. The problem is being investigated and we hope to resolve the issue as soon as possible.", msg);

            }
        }
        //*hide the other screen elements
        $('#working').css("visibility", "hidden");
        toggleScreenElements(true);

        let popupHeader = document.createElement("div");
        let popupContent = document.createElement("div");
        let featureContent = generateHtmlForPopup(feature);

        popupHeader.innerHTML = "<h3>" + mapSettings.popupTitle + "</h3>" + featureContent;
        popupContent.appendChild(popupHeader);

        if (mapSettings.isAsset) {
            //Add report button for different issues
            let anotherIssueButton = document.createElement("div");
            anotherIssueButton.innerHTML = '<br><button type="button" id="btnNewFault" class="btn btn-primary btn-lg">Report a different issue</button>';
            popupContent.appendChild(anotherIssueButton);
        }

        faultsPopup.setLatLng(L.latLng(selectedLatForDisplay, selectedLngForDisplay));
        faultsPopup.setContent(popupContent);
        map.openPopup(faultsPopup);

        window.setTimeout(function () {
            if (faultsPopup.isOpen()) {
                map.closePopup(faultsPopup);
            }
        }, 6000);

        map.on("popupclose", function (e) {
            //*show the other screen elements
            toggleScreenElements(false);
        })

    }

    //*Map Events

    map.on('moveend', function (e) {
        //*update asset legend text with zoom in msg if assets not showing
        let msg = <HTMLElement>document.getElementById('legendZoomMsg');
        let zoomLevel: number = map.getZoom();
        let mapDiv = <HTMLElement>document.getElementById('mapid');
        let mapTooltip = <HTMLElement>document.getElementById('mapTooltip');
        let pinCursor = baseurl + "/images/" + 'cursorPin.png';

        //*Handle tooltip if cursor moves over info layers
        infoLayerGroup.on('mouseover', function () {
            $('.leaflet-interactive').css('cursor', 'pointer');
            mapTooltip.innerHTML = 'Click / tap to view information';
        });

        if (mapSettings.isAsset) {
            infoLayerGroup.on("mouseout", function () {
                mapTooltip.innerHTML = 'Click on the ' + mapSettings.popupTitle.toLowerCase();
            });
        }

        //*Control visibility of fault layers
        if (zoomLevel >= mapSettings.mapLayerMinZoom) {
            mapLayerGroup.addLayer(faultsLayer);
            mapLayerGroup.addLayer(multipleFaultsLayer);
        }
        if (hasZoomedIn && zoomLevel < mapSettings.mapLayerMinZoom) {
            mapLayerGroup.removeLayer(faultsLayer);
            mapLayerGroup.removeLayer(multipleFaultsLayer);
        }

        //*Change tooltip and cursor if event layer displays reports for asset & non asset maps
        if (faultsLayer) {
            faultsLayer.on('mouseover', function () {
                $('.leaflet-interactive').css('cursor', 'pointer');
                mapTooltip.innerHTML = 'Click / tap to view report';
            });
        }
        if (multipleFaultsLayer) {
            multipleFaultsLayer.on('mouseover', function () {
                $('.leaflet-interactive').css('cursor', 'pointer');
                mapTooltip.innerHTML = 'Click / tap to view report';
            });
        }

        //*Control visibility of info layers
        if (mapSettings.infoLayers) {
            if (zoomLevel >= mapSettings.mapLayerMinZoom) {
                infoLayerGroup.addTo(map);
            }
            if (hasZoomedIn && zoomLevel < mapSettings.mapLayerMinZoom) {
                infoLayerGroup.removeFrom(map);
            }
        }

        //*Display council land layer information if zoomed into relevant zoom level
        if (mapSettings.councilMaintainedLayerID) {
            if (hasZoomedIn) {
                councilLandLayer.clearAllEventListeners();
                mapLayerGroup.removeLayer(councilLandLayer);
            }
            let msg2 = <HTMLElement>document.getElementById('legendCouncilZoomMsg');
            //Toggle council land layer visibility and legend information based on zoom level
            if (zoomLevel > councilLayerMinZoomLevel) {
                hasZoomedIn = true;
                msg2.style.display = 'inline';
                councilLandLayer = L.Proj.geoJson(addWFSLayer(mapSettings.councilMaintainedLayerID, getMapExtent()), {
                    style: function () {
                        return {
                            weight: 0,
                            fillColor: 'orange',
                            fillOpacity: 0.5
                        }
                    }
                });
                mapLayerGroup.addLayer(councilLandLayer);
                if (!mapSettings.allow_Private) {
                    councilLandLayer.on("mousemove", function () {
                        mapTooltip.innerHTML = 'Click / tap at the location';
                        $('.leaflet-interactive').css('cursor', 'url("' + pinCursor + '") 16 32, auto');
                    });
                    councilLandLayer.on("mouseover", function () {
                        mapTooltip.innerHTML = 'Click / tap at the location';
                        $('.leaflet-interactive').css('cursor', 'url("' + pinCursor + '") 16 32, auto');
                    });
                    councilLandLayer.on("mouseout", function () {
                        mapTooltip.innerHTML = 'Cannot report at this location';
                        $('.leaflet-interactive').css('cursor', 'not-allowed');
                    });
                } else {
                    $('.leaflet-interactive').css('cursor', 'url("' + pinCursor + '") 16 32, auto');
                    councilLandLayer.on("mousemove", function () {
                        mapTooltip.innerHTML = 'Click / tap at the location';
                        $('.leaflet-interactive').css('cursor', 'url("' + pinCursor + '") 16 32, auto');
                    });
                    councilLandLayer.on("mouseover", function () {
                        mapTooltip.innerHTML = 'Click / tap at the location';
                        $('.leaflet-interactive').css('cursor', 'url("' + pinCursor + '") 16 32, auto');
                    });
                    councilLandLayer.on("mouseout", function () {
                        mapTooltip.innerHTML = 'Click / tap at the location';
                        mapDiv.style.cursor = 'url("' + pinCursor + '") 16 32, auto';
                    });
                }
            }
            if (zoomLevel <= councilLayerMinZoomLevel && hasZoomedIn) {
                msg2.style.display = 'none';
                mapLayerGroup.removeLayer(councilLandLayer);
            }

        }

        if (mapSettings.isAsset) {
            if (hasZoomedIn) {
                mapLayerGroup.removeLayer(assetLayer);
                if (mapSettings.label_Settings?.field) {
                    mapLayerGroup.removeLayer(assetLabelsLayer);
                }
            }
            if (zoomLevel < mapSettings.mapLayerMinZoom) {
                msg.innerHTML = '1. Use the search above or zoom into the map to find the location.<br />2. Click or tap ';
                mapTooltip.innerHTML = 'Scroll to zoom map';
                $('.leaflet-interactive').css('cursor', 'grab');
                if (faultsLayer) {
                    faultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Scroll to zoom map';
                        $('.leaflet-interactive').css('cursor', 'grab');
                    });
                }
                if (multipleFaultsLayer) {
                    multipleFaultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Scroll to zoom map';
                        $('.leaflet-interactive').css('cursor', 'grab');
                    });
                }
            }
            if (zoomLevel >= mapSettings.mapLayerMinZoom) {
                hasZoomedIn = true;
                //*add assets for asset maps
                assetLayer = L.Proj.geoJson(addWFSLayer(mapSettings.mapLayerID, getMapExtent(), mapSettings.mapLayerFilter), {
                    pointToLayer: function (geojson, latlng) {
                        let iconKey = mapSettings.symbology[0].name;
                        if (geojson.properties.LEAFLET_STYLE) {
                            console.log("LEAFLET_STYLE: " + geojson.properties.LEAFLET_STYLE);
                            iconKey = geojson.properties.LEAFLET_STYLE;
                        }
                        let marker = L.marker(latlng, {
                            icon: iconsForAssets[iconKey]
                        });

                        return marker;
                    }
                });
                if (mapSettings.label_Settings?.field) {
                    assetLabelsLayer = L.Proj.geoJson(addWFSLayer(mapSettings.mapLayerID, getMapExtent(), mapSettings.mapLayerFilter), {
                        pointToLayer: function (geojson, latlng) {
                            let marker = L.marker(latlng, {
                                icon: L.divIcon({
                                    html: geojson.properties[mapSettings.label_Settings.field],
                                    className: 'text-below-marker'
                                }),
                                interactive: false
                            });
                            return marker;
                        }
                    });
                    mapLayerGroup.addLayer(assetLabelsLayer);
                }
                mapLayerGroup.addLayer(assetLayer);
                msg.innerHTML = 'Click or tap ';
                mapTooltip.innerHTML = 'Click on the ' + mapSettings.popupTitle.toLowerCase();
                if (faultsLayer) {
                    faultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Click on the ' + mapSettings.popupTitle.toLowerCase();
                    });
                }
                if (multipleFaultsLayer) {
                    multipleFaultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Click on the ' + mapSettings.popupTitle.toLowerCase();
                    });
                }
            }
        } else {

            if (zoomLevel < mapSettings.mapLayerMinZoom) {
                msg.innerHTML = '1. Use the search above or zoom into the map to find the location.<br />2. Click or tap on the map to select a location.';
                //councilLandLayer.clearAllEventListeners();
                mapTooltip.innerHTML = 'Scroll to zoom map';
                let t = map.getContainer();
                //L.DomUtil.removeClass(map.getContainer(), 'pin-cursor-enabled');
                //mapDiv.style.cursor = '';
                $('.leaflet-interactive').css('cursor', 'grab');
                if (faultsLayer) {
                    faultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Scroll to zoom map';
                        $('.leaflet-interactive').css('cursor', 'grab');
                    });
                }
                if (multipleFaultsLayer) {
                    multipleFaultsLayer.on('mouseout', function () {
                        mapTooltip.innerHTML = 'Scroll to zoom map';
                        $('.leaflet-interactive').css('cursor', 'grab');
                    });
                }
            } else {
                msg.innerHTML = 'Click or tap on the map to select a location.';
                //councilLandLayer.clearAllEventListeners();
                if (!mapSettings.allow_Private) {
                    mapTooltip.innerHTML = 'Find location - <span style="color: orange;">█</span> council land only';
                    mapDiv.style.cursor = 'not-allowed';
                    if (faultsLayer) {
                        faultsLayer.on('mouseout', function () {
                            mapTooltip.innerHTML = 'Find location - <span style="color: orange;">█</span> council land only';
                        });
                    }
                    if (multipleFaultsLayer) {
                        multipleFaultsLayer.on('mouseout', function () {
                            mapTooltip.innerHTML = 'Find location - <span style="color: orange;">█</span> council land only';
                        });
                    }
                } else {
                    mapTooltip.innerHTML = 'Click / tap at the location';
                    //mapDiv.style.cursor = 'url("' + pinCursor + '") 16 32, auto';
                    //L.DomUtil.addClass(map.getContainer(), 'pin-cursor-enabled');
                    $('.leaflet-interactive').css('cursor', 'crosshair');
                    if (faultsLayer) {
                        faultsLayer.on("mouseout", function () {
                            mapTooltip.innerHTML = 'Click / tap at the location';
                        });
                    }
                    if (multipleFaultsLayer) {
                        multipleFaultsLayer.on("mouseout", function () {
                            mapTooltip.innerHTML = 'Click / tap at the location';
                        });
                    }
                }
            }

        }
        //*copyright text
        let copyright = <HTMLElement>document.getElementById('copyrightText');
        copyright.innerHTML = mapSettings.oScopyright;

    });

    // Map click events

    //* Click events for info layers
    infoLayerGroup.on('click', function (e: L.LeafletMouseEvent) {

        let latLng = L.latLng(e.latlng.lat, e.latlng.lng);
        showMapPopup(latLng, e.sourceTarget.feature.properties.POPUP_CONTENTS);
        console.log(e);
    });

    //* Click events for all other layers
    mapLayerGroup.on('click', function (e: L.LeafletMouseEvent) {

        console.log(e);
        let latLng = L.latLng(e.latlng.lat, e.latlng.lng);
        let isSmallScreen = $(window).width()! < smallScreenWidth;
        selectedFeatureX = null;
        selectedFeatureY = null;

        //*Hide tooltip
        $("#mapTooltip").css("display", "none");

        //Click events for faults
        if (e.sourceTarget.feature.layer == mapSettings.singleFaultsLayerID) {
            showFaultPopup(e);
        }

        //Click event for asset multiple faults
        if (e.sourceTarget.feature.layer == mapSettings.multipleFaultsLayerID) {
            showFaultPopup(e);
        }

        //Popup if zoomed out too far
        if (map.getZoom() < mapSettings.mapLayerMinZoom) {
            if (e.sourceTarget.feature.layer !== mapSettings.singleFaultsLayerID && e.sourceTarget.feature.layer !== mapSettings.multipleFaultsLayerID) {
                showMapPopup(latLng, zoomInMsgHTLM);
            }
        } else {
            //Map click events for zoomed in map
            if (e.sourceTarget.feature.layer == mapSettings.boroughMaskLayerID) {
                //Click on out of borough
                let msg: string = `<span id="alertPopup"><img src="${exlamationImagePath}"/><p>Sorry, you can only report an incident within the borough.</p>`;
                if (!mapSettings.allow_Private) {
                    msg += `<p>The areas maintained by the council are highlighted on the map in orange.</p></span>`;
                } else {
                    msg += `</span>`;
                }
                showMapPopup(latLng, msg);
            }
            //Create popup template for new reports
            const createPopup = function (land_type?: string) {
                if (!faultsPopup.isOpen()) {
                    $('#working').css("visibility", "visible");
                    if (selectLayer) {
                        selectLayer.remove();
                    }
                    if (highlightLayer) {
                        highlightLayer.remove();
                    }


                    const popUpFromLatLong = function () {
                        selectLayer = L.marker([selectedLatForDisplay, selectedLngForDisplay], {
                            icon: icons['pin']
                        });

                        if (mapSettings.isAsset) {
                            highlightLayer = L.circleMarker(L.latLng(selectedLatForDisplay, selectedLngForDisplay), {
                                color: 'red',
                                fillColor: '#f03',
                                fillOpacity: 0.5,
                                radius: 50
                            }).addTo(map);

                            selectLayer.setOpacity(0);
                        }

                        returnHTMLforNewFaultPopup(selectedLatForDisplay, selectedLngForDisplay, land_type).then(content => {
                            let theMaxWidth: number = 0,
                                theMaxHeight: number = 0;

                            if (isSmallScreen) {
                                theMaxWidth = 270;
                            } else {
                                theMaxWidth = 500;
                            }

                            selectLayer.bindPopup((content), {
                                maxWidth: theMaxWidth
                            });
                            selectLayer.on("popupopen", function (e) {
                                let p = selectLayer.getPopup();
                                //*update after 2 seconds to ensure the google image will fit on the screen
                                setTimeout(function () {
                                    $('#working').css("visibility", "hidden");
                                    p?.update();
                                }, 2000);
                            });
                            selectLayer.addTo(map);
                            selectLayer.openPopup();
                            //*hide the legend and address search
                            toggleScreenElements(true);

                            selectLayer.on("popupclose", function (e) {
                                //selectLayer.remove();
                                //*show the legend and address search
                                toggleScreenElements(false);
                                if (highlightLayer) {
                                    highlightLayer.remove();
                                }
                            })
                        })
                    };


                    selectedLatForDisplay = e.latlng.lat;
                    selectedLngForDisplay = e.latlng.lng;

                    //*Use the coords from the asset feature if available
                    if (e.layer.feature.geometry.type == 'Point') {

                        let xy = e.sourceTarget.feature.geometry.coordinates;
                        selectedFeatureX = xy[0];
                        selectedFeatureY = xy[1];
                    }
                    popUpFromLatLong();
                }
            }

            if (e.sourceTarget.feature.layer == mapSettings.councilMaintainedLayerID) {
                //Clicked on council maintained land layer
                createPopup("council");
            }
            if (e.sourceTarget.feature.layer == mapSettings.boroughBoundaryLayerID && mapSettings.allow_Private) {
                //Clicked inside borough and private reports allowed
                createPopup("private");
            }
            if (e.sourceTarget.feature.layer == mapSettings.boroughBoundaryLayerID && !mapSettings.allow_Private && !mapSettings.isAsset) {
                let msg: string = `<span id="alertPopup"><img src="${exlamationImagePath}"/><p>Sorry, you can only report an incident on council maintained land.</p>`;
                if (!mapSettings.allow_Private) {
                    msg += `<p>The areas maintained by the council are highlighted on the map in orange.</p></span>`;
                } else {
                    msg += `</span>`;
                }
                showMapPopup(latLng, msg);
            }
            if (e.sourceTarget.feature.layer == mapSettings.mapLayerID) {
                //Clicked on an asset
                let featureProperties = e.sourceTarget.feature.properties;
                selectedAssetId = featureProperties.ASSETID;
                if (mapSettings.out_Parameters) {
                    let fieldList: string[] = mapSettings.out_Parameters.split(',');
                    assetAttributes = {};
                    //fieldList.push('UID');
                    fieldList.forEach((e) => {
                        for (let attribute in featureProperties) {
                            if (e == attribute) {
                                assetAttributes[e] = featureProperties[attribute];
                            }
                        }
                    });
                    console.log(assetAttributes);
                }
                createPopup();
            }
        }
    });
}

function getMapExtent() {
    let latlngBounds = map.getBounds();
    let nw = crs.project(latlngBounds.getNorthWest());
    let ne = crs.project(latlngBounds.getNorthEast());
    let sw = crs.project(latlngBounds.getSouthWest());
    let se = crs.project(latlngBounds.getSouthEast());
    let projectedBounds = L.bounds([nw, ne, sw, se]);
    currentMapExtent = projectedBounds?.min?.x + "," + projectedBounds?.min?.y + "," + projectedBounds?.max?.x + "," + projectedBounds?.max?.y;
    return currentMapExtent;
}

function mergeMultipleFaults(geoJson: any) {
    // group features by ASSETID
    const assets = Array.from(
        geoJson.features.reduce((a: any, c: any) => {
            const id = c.properties.ASSETID;
            if (!a.has(id)) a.set(id, []); // <-- initialise each entry with an empty array
            a.get(id).push(c);             // <-- add the feature to the array for that ASSETID
            return a;
        }, new Map())                    // <-- the accumulator is a Map
    );

    // create new features
    const newFeatures = assets.reduce((a: any, c: any) => {
        a.push({
            "type": "Feature",
            "geometry": c[1][0].geometry,  // <-- take geometry from first array entry
            "properties": c[1].map((f: { properties: any; }) => f.properties) // <-- just retain the properties of the feature
        });
        return a;
    }, []);

    // create new feature collection
    const newFc = {
        "type": "FeatureCollection",
        "title": mapSettings.multipleFaultsLayerID,
        "features": newFeatures
    }
    return newFc;
}

/*Some assets (lights) may have additional attributes which the form needs but are not held in the Fault layer
so they need to be read from another layer and looked up whenever another fault is reported on an asset with
an existing OPEN/FIVE fault
*/
function getAttributesForFeaturesWithFaults(layerName: string) {
    let geoJson: any = addWFSLayer(layerName);
    featuresWithFaults = geoJson?.features;

}

function addFeatureInfo(geoJson: any, projection: string, layername: string) {
    geoJson.crs = {
        "type": "name",
        "properties": {
            "name": "urn:ogc:def:crs:EPSG::" + projection
        }
    };
    let geoJsonFeatures = geoJson.features;
    geoJsonFeatures.forEach(function (e: any) {
        e.layer = layername;
    });
    return geoJson;
}

function addWFSLayer(layerName: string, extent?: string, filter?: string) {
    let rootUrl = mapSettings.featureServiceUrl;
    let defaultParameters: any;
    defaultParameters = {
        service: 'WFS',
        request: 'GetFeature',
        srsname: 'EPSG:27700',
        typeName: 'statmap:' + layerName,
        outputFormat: 'geojson'
    };
    if (extent) {
        defaultParameters.bbox = currentMapExtent;
    }
    if (filter) {
        defaultParameters.filter = filter;
    }

    let parameters = L.Util.extend(defaultParameters);
    let URL = rootUrl + L.Util.getParamString(parameters);

    let jsonData;

    $.ajax({
        url: URL,
        async: false,
        crossDomain: true
    }).done(function (response, textStatus, jqXHR) {
        if (!jqXHR.responseJSON) {
            serviceError(URL);
        }
        if (layerName == mapSettings.multipleFaultsLayerID) {
            response = mergeMultipleFaults(response);
        }
        addFeatureInfo(response, "27700", layerName);
        jsonData = response;
        //L.Proj.geoJson(response).addTo(map);
    }).fail(function (jqXHR, textStatus, errorThrown) {
        if (!jqXHR.responseJSON) {
            serviceError(URL);
        }
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
    });

    return jsonData;

}

function addLayers() {

    mapLayerGroup = L.featureGroup().addTo(map);
    infoLayerGroup = L.featureGroup();

    //*configuration settings for different os basemaps
    let basemapConfig = [
        { type: "overview", minZoom: 5, maxZoom: 10 },
        { type: "detailed", minZoom: 11, maxZoom: 13, className: "grayscale" }
    ];

    //*add os basemaps
    basemapConfig.forEach(function (basemap) {
        let cssStyle = (basemap.className != null) ? basemap.className : '';
        let url = mapSettings.oSbaseMapUrl + '/Road_27700/{z}/{x}/{y}.png';
        let tileLayer = L.tileLayer(url, {
            minZoom: basemap.minZoom,
            maxZoom: basemap.maxZoom,
            className: cssStyle,
            attribution: mapSettings.oScopyright
        }).addTo(map);
    });


    //*add borough mask
    boroughMaskLayer = L.Proj.geoJson(addWFSLayer(mapSettings.boroughMaskLayerID), {
        style: function () {
            return {
                color: 'black',
                fillColor: 'white',
                fillOpacity: 0.8
            }
        }
    });
    mapLayerGroup.addLayer(boroughMaskLayer);

    //*add borough boundary
    boroughBoundaryLayer = L.Proj.geoJson(addWFSLayer(mapSettings.boroughBoundaryLayerID), {
        style: function () {
            return {
                color: 'black',
                fillColor: 'white',
                fillOpacity: 0
            }
        }
    });
    mapLayerGroup.addLayer(boroughBoundaryLayer);

    //*add information layers to the map
    if (mapSettings.infoLayers) {
        mapSettings.infoLayers.forEach(function (layer) {
            var infoLayer = L.Proj.geoJson(addWFSLayer(layer.info_layer_id), {
                pointToLayer: function (geojson, latlng) {
                    let iconKey = layer.symbology[0].name;
                    let marker = L.marker(latlng, {
                        icon: iconsForInfoLayers[iconKey]
                    });
                    return marker;
                }
            });
            infoLayerGroup.addLayer(infoLayer);
        });
    }


    //*initialise single faults layer
    faultsLayer = L.Proj.geoJson(addWFSLayer(mapSettings.singleFaultsLayerID, undefined, mapSettings.singleFaultsLayerFilter), {
        //filter: function (feature) {
        //    if (feature.properties.CASE_TYPE.toUpperCase() === mapSettings.event_Type.toUpperCase() && feature.properties.BOROUGH.toUpperCase() === borough?.toUpperCase() && ["OPEN", "FIVE"].includes(feature.properties.STATUS)) {
        //        return true;
        //    }
        //    return false;
        //},
        pointToLayer: function (geojson, latlng) {
            let marker = L.marker(latlng, {
                icon: iconsForStatus[geojson.properties.STATUS]
            });
            return marker;
        }
    });

    //*initialise multiple faults layer
    multipleFaultsLayer = L.Proj.geoJson(addWFSLayer(mapSettings.multipleFaultsLayerID, undefined, mapSettings.multipleFaultsLayerFilter), {
        //filter: function (feature) {
        //    if (feature.properties[0].CASE_TYPE.toUpperCase() === mapSettings.event_Type.toUpperCase() && feature.properties[0].BOROUGH.toUpperCase() === borough?.toUpperCase()) {
        //        return true;
        //    }
        //    return false;
        //},
        pointToLayer: function (geojson, latlng) {
            let statusIcon = "FIVE";
            for (const key of Object.keys(geojson.properties)) {
                const value = geojson.properties[key];
                if (value.STATUS == "OPEN") {
                    statusIcon = "OPEN";
                }
            }
            let marker = L.marker(latlng, {
                icon: iconsForStatus[statusIcon]
            });
            return marker;
        }
    });
}



//#endregion

//#region Async web service calls

function sendErrorEmail(msg: string): Promise<any> {

    const promise: Promise<any> = new Promise((resolve, reject) => {

        $.post({
            url: `${baseurl}/api/emailError`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                body: msg,
                iserror: true
            }),
            dataType: 'json',
        })
            .done(function (result) {
                resolve(result);
            })
            .fail(function (error) {
                console.error(error.responseText);
            });

    })

    return promise;
}

function returnLatLongFromOScoords(x: number, y: number): Promise<L.LatLng> {

    const promise: Promise<L.LatLng> = new Promise((resolve, reject) => {
        let description: string = "";

        $.get(`${mapSettings.spatialServiceUrl}CoordinateConversion/coordinates/OSGB1936BritishNationalGridTN15GM15/${x}/${y}/ETRS89Geodetic`)
            .done(function (result) {
                let coords = L.latLng(result.targetY, result.targetX);
                resolve(coords);
            })
            .fail(function (error) {
                //
                console.error(error.responseText);
                reject(error);
            });

    })

    return promise;
}

function returnLocationDescription(lat: number, lng: number): Promise<string> {

    const promise: Promise<string> = new Promise((resolve, reject) => {
        let description: string = "";
        let pnt = crs.project(L.latLng(lat, lng));
        $.get(`${baseurl}/api/getNearestAddressToPoint/${pnt.x}/${pnt.y}/${borough}`)
            .done(function (result) {
                resolve(result);
            })
            .fail(function (error) {
                resolve("");
                console.error(error.responseText);
            });

    })

    return promise;
}

//#region ENUMS
enum modalType {
    success = "dialogHeaderSuccess",
    info = "dialogHeaderInfo",
    warning = "dialogHeaderWarning"
}
//#endregion

//#region INTERFACES

interface Address {
    FormattedAddress: string;
    Uprn: number;
    Latitude: number;
    Longitude: number;
}

interface MapSettings {
    gisServer: string;
    addressServiceUrl: string;
    spatialServiceUrl: string;
    featureServiceUrl: string;
    mapServiceUrl: string;
    oSbaseMapUrl: string;
    oSbaseMapTextUrl: string;
    singleFaultsLayerID: string;
    singleFaultsLayerFilter: string,
    multipleFaultsLayerID: string;
    multipleFaultsLayerFilter: string;
    boroughMaskLayerID: string;
    boroughBoundaryLayerID: string;
    councilMaintainedLayerID: string;
    mapLayerID: string;
    mapLayerFilter: string,
    mapLayerFaultID: string;
    startUpCoords: number[];
    oScopyright: string;
    esriCopyright: string;
    token: string;
    mapLayerMinZoom: number;
    isAsset: boolean;
    //asset_Layer_Name: string;
    event_Type: string;
    //assetIcon: string;
    symbology: Symbology[];
    label_Settings: LabelSettings;
    popupTitle: string;
    formUrl: string;
    boroughBounds: number[];
    allow_Private: boolean;
    private_Land_Msg: string;
    select_Location_Msg: string;
    out_Parameters: string;
    infoLayers: InfoLayers[];
    no_Legend: boolean;
    //cM_Layer: string;
}
interface Symbology {
    filter: string;
    icon: string;
    name: string;
    iconSize: L.Point;
    iconSizeLegend: number[];
    iconLegendMargins: number[];
    iconAnchor: L.Point;
    popupAnchor: L.Point;
}

interface LabelSettings {
    field: string;
    min_scale: number;
}

interface InfoLayers {
    info_layer_name: string;
    info_layer_id: string;
    symbology: Symbology[];
}

interface FeatureSymbology {
    type: string;
    symbology: Symbology[];
}

interface MapResult {
    latitude: number;
    longitude: number;
    assetid: string;
    case_type: string;
    [key: string]: any; // for your extra assetAttributes
}
//#endregion